import React, { useRef, useState, useMemo, forwardRef, useImperativeHandle, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, useEffect } from 'react';
import { postRecordList } from '../../../service';
import { Select, Tabs, Button } from 'antd';
import { Api as FetchAPI } from '@cui/req';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { cloneDeep } from 'lodash';
import { PlusOutlined } from '@ant-design/icons';

export interface MdmFeatureTableProps {
  value: any;
  filterProps: any;
  metaConfig: any;
  activeKey?: string | undefined;
  mainRecordValue: any;
  showTreeList: any[];
  showTreeData: any;
  _headIdField?: string;
  headIdData?: string;
  onChange: (data: any, isDefault?: boolean) => void;
}

export const MdmFeatureTable: ForwardRefExoticComponent<PropsWithoutRef<MdmFeatureTableProps> & RefAttributes<Record<any, any>>> = forwardRef<Record<any, any>, MdmFeatureTableProps>(
  (
    {
      value = [],
      filterProps,
      activeKey,
      activeData,
      metaConfig,
      mainRecordValue,
      _headIdField,
      headIdData,
      showTreeList,
      showTreeData,
      onChange,
      refList,
      ...others
    },
    ref,
  ) => {
    const featureTableWithRef = useRef<any>();
    const [canAdd, setCanAdd] = useState<boolean>(false);
    const [checkedData, setCheckedData] = useState<any>({});

    const getDefualtValues = async (treeList: any[], bpartType: string) => {
      const isCreate = metaConfig.pageType === 'add';
      if (isCreate) {
        const allType = await getAllType();
        const list: any[] = [];
        treeList?.map((el: any) => {
          const typeList = el.bd_feature_type_number;
          return {
            ...el,
            bd_feature_type_number: !Array.isArray(typeList) ? typeList?.split(',') : typeList,
          };
        }).forEach((el: any) => {
          el.bd_feature_type_number?.forEach((type: string) => {
            allType[type]?.forEach((item: any) => {
              if (item.product_type === el.product_type && item.feature_type === type) {
                const newItem: any = {
                // 产品编码
                  product_code: mainRecordValue?.cpart_code,
                  // 结构部件
                  bd_material_classification_number: el.bd_material_classification_number,
                  // 部件id
                  md_bbom_template_line_id: el.md_bbom_template_line_id,
                  // 特征参数类型
                  bd_feature_type_classification_number: type,
                  // 特征参数
                  feature_code: item.number,
                  // 产品或物料品类
                  product_type: item.product_type,
                  is_default: '1',
                };
                if (_headIdField) {
                  newItem[_headIdField] = headIdData;
                }
                list.push(newItem);
              }
            });
          });
        });
        console.log('FeatureValueList', list);
        onChange && onChange(list, true);
      }
    };

    const getAllType = async () => {
      const listRes = await postRecordList({
        app_id: 'base',
        model_id: 'bd_feature',
      });
      const typeMap: any = {};
      const types = listRes.data?.map((el: any) => el.feature_type).filter((el: string, ind: number, arr: string[]) => arr.indexOf(el) === ind);
      types.forEach((el: string) => {
        const list = listRes.data?.filter((item: any) => item.feature_type === el);
        typeMap[el] = list;
      });
      return typeMap;
    };

    useEffect(() => {
      if (showTreeList && showTreeList.length > 0 && showTreeData && showTreeData.id) {
        getDefualtValues(showTreeList, showTreeData?.id);
      }
    }, [showTreeList, showTreeData]);

    const addfeature = () => {
      const oldValues = cloneDeep(value);
      const newItem: any = {
        product_code: mainRecordValue?.cpart_code,
        md_bbom_template_line_id: activeKey,
        bd_material_classification_number: checkedData?.bd_material_classification_number,
        product_type: activeData?.product_type,
      };
      if (_headIdField) {
        newItem[_headIdField] = headIdData;
      }
      oldValues.push(newItem);
      onChange && onChange(oldValues);
    };

    const getAddInfo = async () => {
      if (activeKey) {
        const res = await postRecordList({
          app_id: 'master_data',
          model_id: 'md_bbom_template_line',
          md_bbom_template_line_id: activeKey,
        });
        const newVal = res.data[0]?.bbom_template_type === '01';
        setCheckedData(res.data[0] || {});
        setCanAdd(newVal);
      } else {
        setCanAdd(false);
        setCheckedData({});
      }
    };

    useMemo(() => {
      getAddInfo();
    }, [activeKey]);

    const validateFields = () => {
      return new Promise(async (resolve, reject) => {
        try {
          await featureTableWithRef.current?.validateFields();
        } catch (err) {
          console.log('err', err)
          reject(err);
        }
        const isRequiredCol = others.columns?.filter((el: any) => el.isRequired)?.map((el: any) => el.dataIndex);
        let flag = true;
        value?.forEach((val: any) => {
          isRequiredCol.forEach((col: string) => {
            if (!val[col]) {
              flag = false;
            }
          });
        });
        if (flag) {
          resolve({
            module: others.moduleID,
            validateFields: flag,
          });
        } else {
          reject({
            module: others.moduleID,
            validateFields: flag,
          });
        }
      });
    };

    useEffect(() => {
      refList?.current.delete(`${others.moduleID},${headIdData}`);
      refList?.current.set(`${others.moduleID},${headIdData}`, {
        validateFields,
      });
    }, [value]);

    return (
      <>
        <AssetModuleTable
          {...others}
          key={activeKey || 'all'}
          rowDelable={false}
          optionColumns={metaConfig?.pageType !== 'view' ? {
            title: '操作',
            valueType: 'option',
            dataIndex: 'options',
            fixed: 'right',
            width: 140,
            align: 'center',
            render: (_text: any, record: any, index: number, rowIndex: number) => (
              <span>
                <Button
                  type="link"
                  disabled={record?.is_default}
                  onClick={() => {
                    const oldValue = cloneDeep(value);
                    if (activeKey) {
                      let ind = -1;
                      const newValue = oldValue.map((el: any) => {
                        if (el[filterProps?.filterField] === activeKey) {
                          ind++;
                          if (ind === rowIndex) {
                            return {
                              ...el,
                              delete: true,
                            };
                          }
                        }
                        return el;
                      });
                      const filterData = newValue.filter((el: any) => !el.delete);
                      onChange && onChange(filterData);
                    }
                  }}
                >
                  删除
                </Button>
              </span>
            ),
          } : false}
          ref={featureTableWithRef}
          value={value.filter((el: any) => activeKey && el[filterProps?.filterField] === activeKey)}
          onChange={(val: any) => {
            if (activeKey) {
              const oldValue = cloneDeep(value);
              let ind = -1;
              const newValue = oldValue.map((el: any) => {
                if (el[filterProps?.filterField] === activeKey) {
                  ind++;
                  return val[ind] || el;
                }
                return el;
              });
              onChange && onChange(newValue);
            }
          }}
          toolBarRender={[
            <>
              {activeKey && canAdd && metaConfig?.pageType !== 'view' && (
                <Button type="primary" ghost onClick={addfeature}>
                  <PlusOutlined /> 新建
                </Button>
              )}
            </>,
          ]}
        />
      </>
    );
  },
);

export default MdmFeatureTable;
